import { render, staticRenderFns } from "./subscription-sidebar.vue?vue&type=template&id=458bc42e&scoped=true&"
import script from "./subscription-sidebar.vue?vue&type=script&lang=js&"
export * from "./subscription-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./subscription-sidebar.vue?vue&type=style&index=0&id=458bc42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458bc42e",
  null
  
)

/* custom blocks */
import block0 from "./subscription-sidebar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports